import { Component, ViewChild} from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { SelectDaysPage } from "../../pages/cancellations/cancellate";
import { ViewController } from 'ionic-angular';


/**
 * Generated class for the FindCustomerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'find-customer',
  templateUrl: 'find-customer.html'
})
export class FindCustomerComponent {
  customers = [];
  items = [];
  @ViewChild('input') myInput ;
  constructor(
    public global: GlobalProvider,
    public viewCtrl: ViewController
  ) {
    this.initializeItems();
    if(this.items.length>100){this.items = this.items.splice(0,100);}
  }

  ngOnInit(){
    setTimeout(() => {
      this.myInput.setFocus();
      console.log('setFocus');
    },1000);
  }

  initializeItems(){
    this.items = Object.keys(this.global.customers).map(key => this.global.customers[key]);
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (
          (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.lastname.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.rut.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.email.toLowerCase().indexOf(val.toLowerCase()) > -1)
        );
      })
    }
    if(this.items.length>100){this.items = this.items.splice(0,100);}
  }

  open(customer){
    this.viewCtrl.dismiss(customer);
  }

  dismiss(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/find-customer/find-customer.ts